"use client";

import { useState } from "react";
import type { TocEntry } from "@/lib/toc";

export default function TableOfContents({ entries }: { entries: TocEntry[] }) {
  const [open, setOpen] = useState(true);
  if (!entries.length) return null;

  return (
    <div className="mb-8 bg-[#c4deff] rounded-2xl overflow-hidden border border-blue-900/10">
      <button
        onClick={() => setOpen((v) => !v)}
        className={`w-full flex items-center justify-between px-5 py-4 text-base font-semibold text-black hover:bg-blue-900/5 transition ${
          open ? "border-b border-blue-900/10" : ""
        }`}
      >
        <span>Table of Contents</span>
        <svg
          className={`w-4 h-4 shrink-0 text-gray-700 transition-transform ${open ? "" : "-rotate-90"}`}
          fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <ol className="px-3 py-3 list-none">
          {entries.map((entry) => (
            <li key={entry.id}>
              <a
                href={`#${entry.id}`}
                className={`flex items-start gap-2 rounded-lg px-2.5 py-2 leading-snug transition hover:bg-white/50 hover:text-blue-700 ${
                  entry.level === 3
                    ? "ml-4 text-sm text-gray-700"
                    : "text-[15px] font-medium text-gray-900"
                }`}
              >
                {entry.level === 3 && (
                  <span className="mt-0.5 text-gray-500">—</span>
                )}
                <span>{entry.text}</span>
              </a>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
